module.exports = __webpack_public_path__ + "img/logout.561946e2.svg";